module.exports = "/assets/career/team/paulina_piwko.png?NTYNGdF";